// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31UE2","requiredAsterisk":"Info_requiredAsterisk__3SLtc"};